import { cn } from "@/lib/utils";
import LanguageSwitcher from "./LanguageSwitcher";

/**
 * Page plein écran avec défilement — boutons bas de formulaire accessibles sur petit écran.
 */
export function FormPageShell({ children, className, centered = true, showLanguage = true }) {
  return (
    <div className={cn("form-page-shell min-h-[100dvh] bg-slate-50", className)}>
      {showLanguage && (
        <div className="sticky top-0 z-50 flex justify-end p-3 sm:p-4 pointer-events-none">
          <div className="pointer-events-auto">
            <LanguageSwitcher compact />
          </div>
        </div>
      )}
      {centered ? (
        <div className="flex min-h-[calc(100dvh-3.5rem)] items-center justify-center p-4 py-8 sm:py-10 -mt-14">
          {children}
        </div>
      ) : (
        <div className="max-w-3xl mx-auto px-4 py-8 sm:py-10">{children}</div>
      )}
    </div>
  );
}

/** Corps scrollable dans une modale flex (header + footer fixes). */
export function DialogScrollBody({ children, className }) {
  return (
    <div className={cn("flex-1 min-h-0 overflow-y-auto overscroll-y-contain px-6 py-2", className)}>
      {children}
    </div>
  );
}
